import Testimonials from './Testimonials';

export default Testimonials;
